
import {Component, Prop, Vue} from 'vue-property-decorator';
import {IForm} from '@/interfaces/form';

@Component({})
export default class RendererForm extends Vue {
  @Prop(Object) private form: IForm | undefined;
  @Prop(Object) private formData: undefined;
  // @Prop(Object) private formValues: undefined;

  private formValues: object = {};

  // public async mounted() {
  // }


  // public async getForm() {
  // }

}
